'use strict';

module.service('dateUtilService', [ 'ASEBIOL_CONSTANTS', dateUtilServiceFn ]);

function dateUtilServiceFn(ASEBIOL_CONSTANTS) {

	var DateTimeFormatMoment = ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT;
	var DateFormatMoment = ASEBIOL_CONSTANTS.DATE_FORMAT_MOMENT;
	var BirtFormat = ASEBIOL_CONSTANTS.DATE_BIRT_FORMAT;
	var du = {};

	du.DateTimeFormatMomentShow = "dddd, D MMMM YYYY, h:mm a";

	du.DateFormatShow = "EEEE, dd MMMM yyyy";
	
	du.DateFormatMomentShow = "dddd, D MMMM YYYY";

	du.formatMomentDate = function(date) {
		if (!date)
			return date;
		return moment(date, DateFormatMoment);
	}
	
	du.toBirtDate = function(date) {
		if (!(moment.isMoment(date))) {
			return moment(date).format(BirtFormat);
		}
		return date.format(BirtFormat);
	}

	du.formatMomentDateTime = function(date) {
		if (!date)
			return date;
		return moment(date, DateTimeFormatMoment);
	}

	du.date2String = function(date) {
		if (!(moment.isMoment(date))) {
			return moment(date).format(DateFormatMoment);
		}
		return date.format(DateFormatMoment);
	}

	du.datetime2String = function(date) {
		if (!(moment.isMoment(date))) {
			return moment(date).format(DateTimeFormatMoment);
		}
		return date.format(DateTimeFormatMoment);
	}
	
	du.format2FullDate = function(date){
		if (!(moment.isMoment(date))) {
			return moment(date).format(this.DateFormatMomentShow);
		}
		return date.format(this.DateFormatMomentShow);
	}
	
	du.format2FullDateTime = function(date){
		if (!(moment.isMoment(date))) {
			return moment(date).format(this.DateTimeFormatMomentShow);
		}
		return date.format(this.DateTimeFormatMomentShow);
	}
	
	du.isValid = function(date){
		if(date == null || angular.isUndefined(date))
			return false;
		if(!moment.isMoment(date))
			return moment(date).isValid();
		return date.isValid();
		
	}

	return du;
}